// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "root-3naqD";
var _4 = "type_account-iEOOp";
var _5 = "icon-Rf3my";
var _6 = "type_review-3R_At";
var _7 = "orderCode-2LDhj";
var _8 = "price-204fx";
var _9 = "security_code-3JW3s";
var _a = "value-c2SC5";
var _b = "download_wrapper-2d3KS";
var _c = "download-12sBv";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "root", _4 as "type_account", _5 as "icon", _6 as "type_review", _7 as "orderCode", _8 as "price", _9 as "security_code", _a as "value", _b as "download_wrapper", _c as "download" }
export default { "__esModule": _1, "tabletMiddle": _2, "root": _3, "type_account": _4, "icon": _5, "type_review": _6, "orderCode": _7, "price": _8, "security_code": _9, "value": _a, "download_wrapper": _b, "download": _c }
